import { Position } from '__generated__/globalTypes';
import { positionShortNames } from 'lib/players';

export type LineupPosition =
  | typeof Position.Goalkeeper
  | typeof Position.Defender
  | typeof Position.Midfielder
  | typeof Position.Forward
  | typeof Position.Unknown;

export type SelectedPlayers = Record<LineupPosition, string | null>;

export const INITIAL_SELECTED_PLAYERS: SelectedPlayers = {
  [Position.Goalkeeper]: null,
  [Position.Defender]: null,
  [Position.Midfielder]: null,
  [Position.Forward]: null,
  [Position.Unknown]: null,
};

export const positionsMap = [
  {
    position: Position.Goalkeeper,
  },
  {
    position: Position.Defender,
  },
  {
    position: Position.Midfielder,
  },
  {
    position: Position.Forward,
  },
  {
    position: Position.Unknown,
    label: positionShortNames['Extra Player'],
  },
];
